import React, { useCallback } from 'react';
import { createFlowProjectVersionAnotherAction, loadFlowProjectsAction } from 'store/reducers/adminFlows/actions';
import { getActiveFlow } from 'store/reducers/adminFlows/getters';
import { closeConfirmationModalAction } from 'store/reducers/modals/actions';
import { useAppDispatch } from 'store';
import { CreateCopyOfVersionModalUI } from 'modules/ui/ManagerOrAdminComponentsUI/ModalsUI/CreateCopyOfVersionModalUI';
import { useSelector } from 'react-redux';
import { ModalComponentType } from 'store/reducers/modals/types';
import Snackbar from 'services/Snackbar';

interface CreateFlowProjectCopyOfVersionModalProps {
  projectId: string;
  projectName: string;
  dateTimeHistory: string;
}

export const CreateFlowProjectCopyOfVersionModal: ModalComponentType<CreateFlowProjectCopyOfVersionModalProps> = ({
  onClose,
  projectId,
  projectName,
  dateTimeHistory,
}) => {
  const dispatch = useAppDispatch();

  const activeFlow = useSelector(getActiveFlow);

  const activeFlowId = activeFlow?.id;

  const onCreateProjectVersionAnother = useCallback(
    async ({ renameValue, runImport }: { renameValue: string; runImport: boolean }) => {
      if (!renameValue) {
        return Snackbar.show('Поле «Название» обязательно для заполнения', 'error');
      }
      if (!activeFlowId) {
        return;
      }

      try {
        const projectVersionCreationParams = {
          projectId,
          name: renameValue,
          flowId: activeFlowId,
          dateTimeHistory,
          runImport,
        };

        const actionCreateProjectVersion = await dispatch(
          createFlowProjectVersionAnotherAction(projectVersionCreationParams),
        ).unwrap();

        if (actionCreateProjectVersion) {
          await dispatch(loadFlowProjectsAction({ flowId: activeFlowId }));
          dispatch(closeConfirmationModalAction());
          onClose();
        }
      } catch (error) {
        console.error('Error creating project version:', error);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeFlowId, projectId, dateTimeHistory, onClose],
  );

  return (
    <CreateCopyOfVersionModalUI
      onRestoreVersionModal={onCreateProjectVersionAnother}
      onClose={onClose}
      projectName={projectName}
    />
  );
};
